import cx from "classnames";

const Badge = ({
  show,
  mobile = false,
  type = "green",
  appointment,
}: {
  show?: boolean;
  mobile?: boolean;
  type?: "green" | "red" | "bottomNav";
  appointment?: boolean;
}) => (
  <span
    className={cx(
      "absolute -translate-y-1/2 right-1 inline-flex items-center justify-center p-1 text-xs font-bold leading-none text-green-100 rounded-full",
      {
        hidden: !show,
        "-right-5": mobile,
        "md:-right-1": !mobile && type === "green",
        "md:right-0.5 md:top-2 md:translate-y-0":
          !mobile && type === "red" && !appointment,
        "top-1 md:right-[5px] md:top-0 md:translate-y-0": appointment,
        "top-1/2": !appointment,
        "bg-green-600": type === "green",
        "bg-ruslan-red": type === "red",
        "bg-ruslan-red !top-1 p-[3px] right-2": type === "bottomNav",
      }
    )}
  />
);

export default Badge;
